<div
  class="form-group order-request-packages-block"
  *ngIf="
    host.showOrderRequestPackagesBlock() ||
    (includePrepaid && host.showOrderRequestPrepaidSection())
  "
>
  <label class="order-request-subsection-label">Packages</label>
  <div class="order-request-package-tabs" role="tablist" aria-label="Package type">
    <button
      *ngFor="let tab of tabs; trackBy: trackTab"
      type="button"
      role="tab"
      class="order-request-package-tab"
      [class.order-request-package-tab--active]="activeTab === tab.key"
      [attr.aria-selected]="activeTab === tab.key"
      [attr.aria-disabled]="tab.disabled"
      [disabled]="tab.disabled"
      (click)="selectTab(tab)"
    >
      {{ tab.label }}
    </button>
  </div>
  <div
    class="radio-card-group order-request-packages-radio-group"
    *ngIf="!host.isLoadingPackages && activeTab !== 'prepaid'"
  >
    <div class="package-section" *ngIf="activeTab === 'single'">
      <ng-container
        *ngFor="let expandedPackage of host.singleWashPackages"
        [ngTemplateOutlet]="packageCard"
        [ngTemplateOutletContext]="{ $implicit: expandedPackage, monthly: false }"
      ></ng-container>
      <p
        class="order-request-packages-empty error-message"
        *ngIf="showPackagesEmptyMessage('single')"
      >
        {{ emptyMessage('single') }}
      </p>
    </div>
    <div class="package-section" *ngIf="activeTab === 'monthly'">
      <ng-container
        *ngFor="let expandedPackage of host.monthlyPackages"
        [ngTemplateOutlet]="packageCard"
        [ngTemplateOutletContext]="{ $implicit: expandedPackage, monthly: true }"
      ></ng-container>
      <p
        class="order-request-packages-empty error-message"
        *ngIf="showPackagesEmptyMessage('monthly')"
      >
        {{ emptyMessage('monthly') }}
      </p>
    </div>
  </div>
  <ng-container *ngIf="includePrepaid && activeTab === 'prepaid'">
    <app-order-request-prepaid-cards
      [host]="host"
      [loading]="host.isLoadingOrderRequestPrepaid"
      [selectable]="true"
    />
    <p class="order-request-packages-empty error-message" *ngIf="showPrepaidEmptyMessage()">
      {{ emptyMessage('prepaid') }}
    </p>
    <div
      class="order-request-prepaid-detail-panel"
      *ngIf="
        host.orderRequestSelectedPrepaidBookId && host.getOrderRequestPrepaidDetailRows().length > 0
      "
    >
      @for (row of host.getOrderRequestPrepaidDetailRows(); track row.id) {
        <div class="order-request-prepaid-detail-row">
          <span class="order-request-prepaid-detail-row__name">{{ row.washLine }}</span>
          <span class="order-request-prepaid-detail-row__expiry">{{ row.expiryLine }}</span>
        </div>
      }
    </div>
  </ng-container>
  <ng-container *ngIf="host.isLoadingPackages">
    <ng-container *ngTemplateOutlet="host.orderRequestCardsShimmer"></ng-container>
  </ng-container>
</div>

<!--
  Single-wash and monthly tiles differ only in the membership allowance line, the price line
  and the single-wash custom-price editor, so both tabs render this one card template.
  The wash type itself is named once, by the active tab above the tiles.
-->
<ng-template #packageCard let-expandedPackage let-monthly="monthly">
  <label
    class="radio-card"
    [class.radio-card--themed]="!!cardTheme(expandedPackage, monthly)"
    [class.radio-card--default-theme]="!host.themeColorForPackage(expandedPackage.package)"
    [class.selected]="host.isExpandedPackageSelected(expandedPackage)"
    [class.radio-card--monthly]="monthly"
    [class.disabled]="host.shouldDisableField('package')"
    role="radio"
    [attr.aria-checked]="host.isExpandedPackageSelected(expandedPackage)"
    [attr.aria-disabled]="host.shouldDisableField('package')"
    [attr.tabindex]="host.shouldDisableField('package') ? -1 : 0"
    (click)="host.onExpandedPackageCardClick(expandedPackage, $event)"
    (keydown.enter)="onKeyboardSelect($event, expandedPackage)"
    (keydown.space)="onKeyboardSelect($event, expandedPackage)"
  >
    <span
      *ngIf="cardTheme(expandedPackage, monthly) as packageTheme"
      class="order-request-theme-fill"
      [class.order-request-theme-fill--light]="host.isLightTheme(packageTheme)"
      [style.background]="packageTheme"
      aria-hidden="true"
    ></span>
    <input
      type="radio"
      tabindex="-1"
      [name]="radioName"
      [value]="expandedPackage.uniqueId"
      [checked]="host.isExpandedPackageSelected(expandedPackage)"
      [disabled]="host.shouldDisableField('package')"
      (change)="host.onExpandedPackageSelect(expandedPackage)"
    />
    <div class="radio-card-content">
      <div class="radio-card-header">
        <span class="radio-card-title" [attr.title]="expandedPackage.displayName">{{
          expandedPackage.displayName
        }}</span>
        <span class="radio-indicator"></span>
      </div>
      <div class="radio-card-price" *ngIf="monthly">
        <span class="wash-type-label">{{ host.getMonthlyWashCardLabel(expandedPackage) }}</span>
      </div>
      <span class="price-label" *ngIf="monthly">{{
        host.formatUsdPriceForOrderRequestDisplay(expandedPackage.price)
      }}</span>
      <span class="price-label" *ngIf="!monthly && !expandedPackage.allowsCustomPrice">{{
        host.formatExpandedSingleWashListPriceDisplay(expandedPackage)
      }}</span>
      <ng-container *ngIf="!monthly && expandedPackage.allowsCustomPrice">
        <div
          class="order-request-addon-card order-request-single-wash-nested"
          [class.order-request-addon-card--selected]="
            host.isExpandedPackageSelected(expandedPackage)
          "
          [class.order-request-addon-card--expanded]="
            host.isOrderRequestSingleWashCustomExpanded(expandedPackage.uniqueId)
          "
          [class.order-request-addon-card--disabled]="host.shouldDisableField('package')"
        >
          <div
            class="order-request-addon-card__header order-request-addon-card__header--actions-below"
          >
            <div class="order-request-addon-card__header-actions">
              <div
                class="order-request-addon-card__saved-row"
                *ngIf="
                  host.formatOrderRequestSingleWashSavedPrice(expandedPackage.uniqueId) &&
                  !host.isOrderRequestSingleWashCustomExpanded(expandedPackage.uniqueId)
                "
              >
                <span class="order-request-addon-card__price-value">{{
                  host.formatOrderRequestSingleWashSavedPrice(expandedPackage.uniqueId)
                }}</span>
                <button
                  type="button"
                  class="order-request-addon-card__edit-btn"
                  (click)="host.onOrderRequestSingleWashEditCustomPrice(expandedPackage, $event)"
                  [attr.aria-label]="'Edit custom price for ' + expandedPackage.displayName"
                >
                  <svg
                    class="order-request-addon-card__edit-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
                    <path d="m15 5 4 4" />
                  </svg>
                </button>
              </div>
              <button
                *ngIf="
                  host.isOrderRequestSingleWashCustomExpanded(expandedPackage.uniqueId) ||
                  !host.formatOrderRequestSingleWashSavedPrice(expandedPackage.uniqueId)
                "
                type="button"
                class="order-request-addon-pill order-request-addon-pill--outline"
                (click)="host.onSingleWashPackageCustomPricePillClick(expandedPackage, $event)"
                [disabled]="host.shouldDisableField('package')"
              >
                Custom Price
              </button>
            </div>
          </div>
          <div
            class="order-request-addon-card__editor"
            *ngIf="host.isOrderRequestSingleWashCustomExpanded(expandedPackage.uniqueId)"
            (click)="$event.stopPropagation()"
          >
            <label
              class="order-request-addon-card__amount-label"
              [attr.for]="customPriceIdPrefix + expandedPackage.uniqueId"
              >Enter amount</label
            >
            <div class="order-request-addon-card__amount-input-wrap">
              <span class="order-request-addon-card__currency" aria-hidden="true">$</span>
              <input
                type="text"
                class="order-request-addon-card__amount-input"
                [id]="customPriceIdPrefix + expandedPackage.uniqueId"
                [ngModel]="host.getOrderRequestSingleWashCustomPriceDraft(expandedPackage.uniqueId)"
                (ngModelChange)="
                  host.onOrderRequestSingleWashCustomPriceInput(expandedPackage.uniqueId, $event)
                "
                inputmode="decimal"
                autocomplete="off"
                placeholder="0.00"
              />
            </div>
            <div class="order-request-addon-card__editor-actions">
              <button
                type="button"
                class="order-request-addon-card__save-btn"
                (click)="
                  $event.stopPropagation();
                  host.saveOrderRequestSingleWashCustomPrice(expandedPackage)
                "
              >
                Save
              </button>
              <button
                *ngIf="host.formatOrderRequestSingleWashSavedPrice(expandedPackage.uniqueId)"
                type="button"
                class="order-request-addon-card__clear-price-btn"
                (click)="
                  $event.stopPropagation();
                  host.removeOrderRequestSingleWashCustomPrice(expandedPackage, $event)
                "
              >
                Clear price
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </label>
</ng-template>
